<script setup>
import {defineProps, ref} from 'vue';
import ReportsTable from '@/core/components/table/ReportsTable';

const props = defineProps({
  reportId: {
    type: Number,
    required: true,
  },
  reportName: {
    type: String,
    required: true,
  },
  reportType: {
    type: String,
    required: true,
  },
  reportTypeDefined: {
    type: String,
    required: true,
  },
});

const filters = ref({
  reportId: props.reportId,
});

const onExport = type => {
  const url = `${window.appGlobal.baseUrl}/api/v2/training/${props.reportType}/export/${props.reportId}/${type}`;
  window.open(url, '_blank');

  /*
  this.http.request({
    url: `/api/v2/leave/leaves/export`,
    method: 'POST',
  });
  */
};
</script>

<template>
  <reports-table
    module="training"
    :name="reportTypeDefined.toLowerCase()"
    :prefetch="true"
    :filters="filters"
    :show-export-btn="true"
    @exportPdf="onExport('pdf')"
    @exportExcel="onExport('excel')"
  >
    <div class="orangehrm-card-container">
      <oxd-text tag="h6" class="orangehrm-main-title">
        {{ reportName }}
      </oxd-text>
    </div>
    <br />
  </reports-table>
</template>
